import React, { useEffect } from "react";
import { openPopupWidget } from "react-calendly";
import PrimaryBtn from "./Primary";
import OutlineBtn from "./Outline";
import LinkBtn from "./Link";
import ModulePrimaryBtn from "./ModulePrimaryBtn";
import ModuleOutlineBtn from "./ModuleOutlineBtn";
import ModuleNavButton from "./ModuleNavButton";

const CalendlyBtn = props => {
  const { children, buttonType, className, url, variant } = props;

  const onClick = () =>
    openPopupWidget({
      url
    });

  // Conversion tracking for calendly success event - https://developer.calendly.com/api-docs/ZG9jOjI3ODM2MTAz-notifying-the-parent-window
  // Fire demo_requested event to segment as we already have conversion tracking reporting built out for that event.
  useEffect(() => {
    const calendlyAnalyticsHandler = event => {
      if (event.data.event && event.data.event === "calendly.event_scheduled") {
        window.analytics.track("demo_requested");
      }
    };
    window.addEventListener("message", calendlyAnalyticsHandler);
    return () => {
      window.removeEventListener("message", calendlyAnalyticsHandler);
    };
  });

  switch (buttonType) {
    case "Primary":
      return (
        <PrimaryBtn onClick={onClick} className={className}>
          {children}
        </PrimaryBtn>
      );
    case "Outline":
      return (
        <OutlineBtn onClick={onClick} className={className}>
          {children}
        </OutlineBtn>
      );
    case "Link":
      return (
        <LinkBtn onClick={onClick} className={className}>
          {children}
        </LinkBtn>
      );
    case "ModulePrimary":
      return (
        <ModulePrimaryBtn onClick={onClick} className={className}>
          {children}
        </ModulePrimaryBtn>
      );
    case "ModuleOutline":
      return (
        <ModuleOutlineBtn onClick={onClick} className={className}>
          {children}
        </ModuleOutlineBtn>
      );
    case "ModuleNavButton":
      return (
        <ModuleNavButton type={variant} onClick={onClick} className={className}>
          {children}
        </ModuleNavButton>
      );
    default:
      return (
        <PrimaryBtn onClick={onClick} {...props}>
          {children}
        </PrimaryBtn>
      );
  }
};

CalendlyBtn.defaultProps = {
  buttonType: "Primary",
  url: "https://calendly.com/d/dqs-f6v-92s?primary_color=39920e"
};

export default CalendlyBtn;
